import React from 'react';
import { reduxForm, Field, isDirty, formValueSelector } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import { connect } from 'react-redux';
import { changeOutletName } from 'actions/setting/receipt';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import withFeatureFlags from 'hocs/withFeatureFlags';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import uploadIcon from 'assets/images/upload-outlet-logo.png';
import isValidWebsiteUrl from 'utils/validators/isValidWebsiteUrl';
import isValidFacebookName from 'utils/validators/isValidFacebookName';
import isValidTwitterName from 'utils/validators/isValidTwitterName';
import {
  settingReceiptUploadLogo as settingReceiptUploadLogoClevertap,
  settingReceiptUpdateWebsite as settingReceiptUpdateWebsiteClevertap,
  settingReceiptUpdateTwitter as settingReceiptUpdateTwitterClevertap,
  settingReceiptUpdateFacebook as settingReceiptUpdateFacebookClevertap,
  settingReceiptUpdateInstagram as settingReceiptUpdateInstagramClevertap,
} from 'clevertap/settings/receipt';
import styles from './ReceiptForm.css';
import Header from './Header';

const validate = (values, props) => {
  const { enableSocialMediaValidation } = props;
  const FIELD_REQUIRED_ERROR = 'This field is required';
  const errors = {};
  if (!values.name) {
    errors.name = FIELD_REQUIRED_ERROR;
  }

  if (!values.address) {
    errors.address = FIELD_REQUIRED_ERROR;
  }

  if (!values.city) {
    errors.city = FIELD_REQUIRED_ERROR;
  }

  if (!values.province) {
    errors.province = FIELD_REQUIRED_ERROR;
  }

  if (!values.zipcode || !/^\d{5}$/.test(values.zipcode)) {
    errors.zipcode = FIELD_REQUIRED_ERROR;
  }

  if (!values.phone) {
    errors.phone = FIELD_REQUIRED_ERROR;
  }

  if (enableSocialMediaValidation) {
    if (!isValidWebsiteUrl(values.website)) {
      errors.website = 'URL must start with `http` or `https`';
    }

    if (!isValidFacebookName(values.facebook)) {
      errors.facebook =
        'Only alphabets, numbers, underscores and dots are allowed';
    }

    if (!isValidTwitterName(values.twitter)) {
      errors.twitter =
        'Only alphabets, numbers, underscores and dots are allowed';
    }
  }

  return errors;
};

class ReceiptForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      uploading: false,
    };
  }

  render() {
    const { enableReceiptLogoPerOutlet, outletLogo, outletName } = this.props;

    return (
      <form
        className={`${styles.wrapper} receipt-wrapper`}
        onSubmit={this.props.handleSubmit}
        id="form-receipt"
      >
        {enableReceiptLogoPerOutlet && <Header title="outlet logo" />}
        {enableReceiptLogoPerOutlet && (
          <div className="row">
            <div className="form-group">
              <div className="col-md-3">
                <Field
                  name="logo"
                  component={UploadImage}
                  defaultImage={uploadIcon}
                  imageContainerClassName=""
                  className={styles['upload-image']}
                  beforeUpload={() => {
                    this.setState({ uploading: true });
                  }}
                  afterUpload={() => {
                    this.setState({ uploading: false });
                    this.uploadOutletLogo();
                  }}
                />
              </div>
              <div className="col-md-9">
                <p className={styles['upload-instructions']}>
                  If you choose not to upload anything, outlet logo will set to
                  default to image uploaded in
                  <a href="/settings/public_profile"> public profile page. </a>
                  Uploading image here will only affect selected outlet logo (
                  {outletName}) and make the business name in receipt changed to
                  Outlet Name.
                </p>
              </div>
            </div>
          </div>
        )}
        <Header title="outlet info" />
        <div className={`row ${styles['field-wrapper']}`}>
          <div className="col-lg-12">
            <div className="form-group">
              <Field
                component={SettingField}
                className="form-control"
                name="name"
                type="text"
                maxLength="40"
                placeholder="Outlet Name"
                onChange={this._onChangeOutletName}
              />
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-group">
              <Field
                component={SettingField}
                className="form-control"
                name="address"
                type="text"
                maxLength="90"
                placeholder="Address"
              />
            </div>
          </div>
          <div className={`${styles['custom-receipt']} col-md-4`}>
            <div className="form-group">
              <Field
                component={SettingField}
                className="form-control"
                name="city"
                type="text"
                maxLength="40"
                placeholder="City"
              />
            </div>
          </div>
          <div className={`${styles['custom-receipt']} col-md-4`}>
            <div className="form-group">
              <Field
                component={SettingField}
                className="form-control"
                name="province"
                type="text"
                placeholder="State"
                maxLength="40"
              />
            </div>
          </div>
          <div className={`${styles['custom-receipt']} col-md-4`}>
            <div className="form-group">
              <Field
                component={SettingField}
                name="zipcode"
                className="form-control"
                pattern="[0-9]{5}"
                maxLength="5"
                placeholder="Zip"
                autoCorrect="off"
                type="tel"
                autoCapitalize="off"
                positiveNumberOnly
                maxFractionDigits={0}
                spellCheck="false"
              />
            </div>
          </div>
          <div className={`${styles['custom-receipt']} col-xs-12`}>
            <div className="form-group">
              <Field
                component={PhoneNumberField}
                name="phone"
                type="tel"
                placeholder="812"
              />
            </div>
          </div>

          {enableReceiptLogoPerOutlet && outletLogo && (
            <div className="col-md-12">
              <Header title="links" />
            </div>
          )}
          {enableReceiptLogoPerOutlet && outletLogo && (
            <div>
              <div className={`${styles['social-links']} col-md-12`}>
                <div className="form-group">
                  <div className="col-md-1">
                    <span className={`fa-stack ${styles['color-link']}`}>
                      <i className="fa fa-circle fa-stack-2x" />
                      <i className="fa fa-globe fa-stack-1x fa-inverse" />
                    </span>
                  </div>
                  <div className="col-md-11">
                    <Field
                      component={SettingField}
                      className="form-control"
                      name="website"
                      type="text"
                      maxLength="50"
                      placeholder="Website"
                      onFocus={this.changeOutletWebsite}
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles['social-links']} col-md-12`}>
                <div className="form-group">
                  <div className="col-md-1">
                    <span className={`fa-stack ${styles['color-twitter']}`}>
                      <i className="fa fa-circle fa-stack-2x" />
                      <i className="fa fa-twitter fa-stack-1x fa-inverse" />
                    </span>
                  </div>
                  <div className="col-md-11">
                    <Field
                      component={SettingField}
                      className="form-control"
                      name="twitter"
                      type="text"
                      maxLength="50"
                      placeholder="Twitter"
                      onFocus={this.changeOutletTwitter}
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles['social-links']} col-md-12`}>
                <div className="form-group">
                  <div className="col-md-1">
                    <span className={`fa-stack ${styles['color-facebook']}`}>
                      <i className="fa fa-circle fa-stack-2x" />
                      <i className="fa fa-facebook fa-stack-1x fa-inverse" />
                    </span>
                  </div>
                  <div className="col-md-11">
                    <Field
                      component={SettingField}
                      className="form-control"
                      name="facebook"
                      type="text"
                      maxLength="50"
                      placeholder="Facebook"
                      onFocus={this.changeOutletFacebook}
                    />
                  </div>
                </div>
              </div>
              <div className={`${styles['social-links']} col-md-12`}>
                <div className="form-group">
                  <div className="col-md-1">
                    <span className={`fa-stack ${styles['color-facebook']}`}>
                      <i className="fa fa-circle fa-stack-2x" />
                      <i className="fa fa-instagram fa-stack-1x fa-inverse" />
                    </span>
                  </div>
                  <div className="col-md-11">
                    <Field
                      component={SettingField}
                      className="form-control"
                      name="instagram"
                      type="text"
                      maxLength="50"
                      placeholder="Instagram"
                      onFocus={this.changeOutletInstagram}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="col-md-12">
            <br />
            <hr />
            <Header title="notes" />
          </div>
          <div className="col-lg-12">
            <Field
              component="textarea"
              className="form-control"
              name="notes"
              maxLength="100"
              placeholder="Notes"
              rows="3"
            />
          </div>
          <div className="col-md-12" style={{ height: 25 }} />
          <div className={styles.footer}>
            <span className="pull-right">
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </span>
          </div>
        </div>
      </form>
    );
  }

  _onChangeOutletName = e => {
    const { outlets } = this.props.data.outlet;
    const { profile } = this.props.data.setting.receipt;
    this.props.dispatch(changeOutletName(e.target.value, outlets, profile));
  };

  sendClevertapEvent(eventType) {
    const eventMap = {
      logo: settingReceiptUploadLogoClevertap,
      website: settingReceiptUpdateWebsiteClevertap,
      twitter: settingReceiptUpdateTwitterClevertap,
      facebook: settingReceiptUpdateFacebookClevertap,
      instagram: settingReceiptUpdateInstagramClevertap,
    };

    const fn = eventMap[eventType];
    if (fn) {
      const { profile } = this.props.data.setting.receipt;

      if (profile) {
        const outletId = profile.outlet_id[0];
        for (const outlet of profile.outlets) {
          if (outlet.id === outletId) {
            fn(outlet);
          }
        }
      }
    }
  }

  uploadOutletLogo = () => {
    this.sendClevertapEvent('logo');
  };

  changeOutletWebsite = () => {
    this.sendClevertapEvent('website');
  };

  changeOutletTwitter = () => {
    this.sendClevertapEvent('twitter');
  };

  changeOutletFacebook = () => {
    this.sendClevertapEvent('facebook');
  };

  changeOutletInstagram = () => {
    this.sendClevertapEvent('instagram');
  };
}

ReceiptForm.propTypes = {};

ReceiptForm.defaultProps = {
  enableReceiptLogoPerOutlet: false,
};

const mapForm = {
  form: 'checkout',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const mapStateToProps = state => {
  const selector = formValueSelector('checkout');
  return {
    data: {
      isDirtyForm: isDirty('checkout')(state),
      outlet: state.outlet,
      setting: {
        receipt: state.setting.receipt,
      },
    },
    outletLogo: selector(state, 'logo'),
    outletName: selector(state, 'name'),
  };
};

const connected = connect(mapStateToProps)(reduxForm(mapForm)(ReceiptForm));

const mapFlagsToProps = flags => {
  return {
    enableReceiptLogoPerOutlet: flags.receiptLogoPerOutlet,
    enableSocialMediaValidation: flags.enableInputValidationForReceiptLogo,
  };
};

export default withFeatureFlags(mapFlagsToProps)(connected);
